<template>

	<div class="page-toolbar">

		<select class="form-control" name="language" v-model="$language.current">
			<option v-for="(language, key) in $language.available" :value="key">{{ language }}</option>
		</select>

	</div>

</template>

<script>

	import AvailableLanguages from './';
	export default AvailableLanguages;

</script>

<style lang="scss" scoped>

	.page-toolbar {

		.form-control {
			height: 40px;
		}

	}

</style>



// WEBPACK FOOTER //
// available-languages.vue?89b888fa